import { Theme } from 'baseui';
import StyleBreakpoint from 'common/styles/styles.breakpoint';
import { themedStyled } from 'common/styles/styletron.theme';

export const Content = themedStyled('div', ({ $theme }) => ({
  height: 'calc(100vh - 64px)',
  overflow: 'hidden',
  display: 'flex',
  flex: 1,
  position: 'relative',
  flexDirection: 'row',
}));

export const ScrollArea = themedStyled('div', {
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const LayoutContainer = themedStyled('div', {
  height: '100%',
  width: '100%',
});

export const OverlayContainer = themedStyled<
  'div',
  { $isActive: boolean },
  Theme
>('div', ({ $isActive }) => {
  return {
    transition: 'all .2s ease',

    [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
      ...($isActive
        ? {
            position: 'absolute',
            width: '100%',
            height: '100%',
            zIndex: 200,
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            backgroundColor: 'rgba(0,0,0,0.5)',
          }
        : {}),
    },
  };
});
